// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'
import Touch from 'vue2-touch-events'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
require('../node_modules/bootstrap/scss/bootstrap.scss')
require('../src/assets/scss/site.scss')
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueResize from 'vue-resize'
Vue.use(VueResize)

Vue.use(BootstrapVue)
Vue.use(VueResource)
Vue.use(Vuex)
Vue.use(Touch, {
  disableClick: false,
  touchClass: 'touch',
  tapTolerance: 10,
  swipeTolerance: 30
})
Vue.component('icon', Icon)

Vue.config.productionTip = false

const store = new Vuex.Store({
  state: {
    isEnhanced: localStorage.getItem('enhancedView') === 'true',
    dataUrlArticle: require('./assets/mocks/article_mock.png'),
    dataUrlArticleList: require('./assets/mocks/article-list_mock.png'),
    dataUrlIssue: require('./assets/mocks/issue_mock.png'),
    // TODO: remove path to mock file after services implementation
    dataUrlMockFile: require('./assets/mocks/mock.png')
  },
  mutations: {
    setMode (state, isEnhanced) {
      state.isEnhanced = isEnhanced
      localStorage.setItem('enhancedView', isEnhanced)
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js